var map = {
	"./aave.svg": 973,
	"./bluestone.svg": 974,
	"./compound.svg": 975,
	"./ddex.svg": 976,
	"./dydx.svg": 977,
	"./fulcrum.svg": 978,
	"./kyber.svg": 979,
	"./metamask.svg": 168,
	"./nuo.svg": 980,
	"./oasis.svg": 981,
	"./radar.svg": 982,
	"./synthetix.svg": 983,
	"./tokenlon.svg": 984,
	"./tokensets.svg": 985,
	"./tornado.svg": 986,
	"./uniswap.svg": 987
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 972;